import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import MainPurchaseList from '../../purchase/MainPurchaseList';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';

@observer
export class MyAccountPurchasesList extends Component {
  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount
      },
      {
        text: intl.formatMessage(globalTranslations.purchasesListTitle),
        url: Paths.MyAccountPurchasesList
      }
    ]);
  };

  render() {
    return (
      <Fragment>
        <SEOTitle title={globalTranslations.purchasesListTitle} />
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <PageTitle>
          <FormattedMessage {...globalTranslations.purchasesListTitle} />
        </PageTitle>
        <div className="MyAccountPurchasesList">
          <MainPurchaseList />
        </div>
      </Fragment>
    );
  }
}

MyAccountPurchasesList.propTypes = {
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired
};

export default injectIntl(inject('routeService')(MyAccountPurchasesList));



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountPurchasesList/index.jsx